import React, {Component} from "react";
import {SortableTableHeader} from "../../components/table/sortable-table-header";

export default class DocumentTableHeader extends Component
{
  static Layout = [
      { column: "documentName", width: 2 , name: "Title" },
      { column: "documentExt", width: 3 , name: "Document Type" },
      { column: "uploadedBy" , width: 3 , name: "Author" },
      { column: "dateCreated", width: 3 , name: "Upload Date" },
      { column: "empty", width: 2 }
  ];

  render() {
      return (
          <SortableTableHeader column={this.props.column} direction={this.props.direction} onChangeSort={this.props.onChangeSort} headings={DocumentTableHeader.Layout}/>
      )
  }
}
